import { defineComponent } from 'vue';
import { hasFeature, hasPermission, Permissions } from '@/ui/auth/auth';
import { renderAnalyticsTeaserPage } from '@/ui/pages/teasers/AnalyticsTeaserPage';
import { renderForbiddenPage } from '@/ui/pages/error/ForbiddenPage';
import {
  categoryFilter,
  checklistFilter,
  dateRangeFilter,
  filterContainer,
  groupFilter,
  questionTitleFilter,
  responseFilter,
  sectionFilter,
  entityItemFilter,
  entityFolderFilter,
  userFilter,
} from '@/ui/components/filters';
import { loader } from '@/ui/components';
import { useQueryFiltering } from '@/ui/pages/analytics/Overview/useQueryFilters';
import { useFilters } from '@/ui/pages/analytics/NegativeResponses/useFilters';

export const OverviewPageFilters = defineComponent({
  name: 'OverviewPageFilters',
  setup() {
    if (!hasFeature('analytics')) {
      return renderAnalyticsTeaserPage;
    }

    if (!hasPermission(Permissions.VIEW_ALL_ANALYTICS)) {
      return renderForbiddenPage;
    }

    const queryFilters = useQueryFiltering();

    const {
      start,
      end,
      group,
      entityItem,
      entityFolder,
      user,
      category,
      checklist,
      questionTitle,
      response,
      section,
    } = queryFilters;

    const {
      getFilters,
      entityItems,
      entityFolders,
      groups,
      users,
      categories,
      checklists,
      sections,
    } = useFilters();

    return function render() {
      return filterContainer([
        loader('form', getFilters, [
          dateRangeFilter(start, end),
          entityItemFilter(entityItem, entityItems.value),
          entityFolderFilter(entityFolder, entityFolders.value),
          groupFilter(group, groups.value),
          userFilter(user, users.value),
          categoryFilter(category, categories.value),
          checklistFilter(checklist, checklists.value),
          questionTitleFilter(questionTitle),
          responseFilter(response),
          sectionFilter(section, sections.value),
        ]),
      ]);
    };
  },
});
